import { showError, showSuccess } from '@calendly/alert';
import { I18n } from '@calendly/i18n';
import { InlineBanner } from '@calendly/ui/components/inline-banner';
import { useDispatch } from 'react-redux';
import { useEnableAssistant } from 'hooks/scheduling_assistant';
const disabledBannerCss = "d19f9j78";
export const CallieDisabledBanner = () => {
  const dispatch = useDispatch();
  const {
    enableAssistant,
    isEnabling
  } = useEnableAssistant();
  const handleEnableCallie = () => {
    if (isEnabling) return;
    const run = async () => {
      // TODO: consider accounting for the scenario where a user previously disabled the assistant and we want to
      // retain their previous event type selection. See https://github.com/calendly/mf-publisher/pull/2636#discussion_r3269381862.
      // We can fetch and pass an event type uuid to the enableAssistant function to retain the previous selection.
      const outcome = await enableAssistant();
      if (outcome.noEligibleEventType) {
        dispatch(showError(I18n.t('publisher.personal_settings.scheduling_assistant.disabled.no_default_event_type')));
        return;
      }
      if (outcome.ok) {
        dispatch(showSuccess(I18n.t('publisher.personal_settings.scheduling_assistant.disabled.set_up_success')));
        return;
      }
      if (outcome.error) {
        dispatch(showError(I18n.t('publisher.personal_settings.scheduling_assistant.disabled.set_up_error')));
      }
    };
    run().catch(() => {});
  };
  return <div className={disabledBannerCss}>
      <InlineBanner variant="info" isDismissible={false} title={I18n.t('publisher.home.scheduling_subsection.callie.disabled_banner.title')} message={I18n.t('publisher.home.scheduling_subsection.callie.disabled_banner.message')} primaryButton={{
      label: I18n.t('publisher.home.scheduling_subsection.callie.disabled_banner.primary_button'),
      decoration: 'primary',
      onClick: handleEnableCallie,
      loading: isEnabling
    }} />
    </div>;
};

require("./callie_disabled_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./callie_disabled_banner.js");